module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', {
    attrs: {
      "title": "Valores da Guia de Medidas"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Nome da Guia de Medidas",
      "required": true,
      "error": _vm.getError('name'),
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sizeGrid.name),
      expression: "sizeGrid.name"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sizeGrid.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sizeGrid, "name", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Tabela de Tamanhos"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Comprimento do Pé")]), _vm._v(" "), _c('th', [_vm._v("BR")]), _vm._v(" "), _c('th', [_vm._v("US")]), _vm._v(" "), _c('th', [_vm._v("EU")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sizeGrid.sizes), function(size, i) {
    return (_vm.sizeGrid) ? _c('tr', [(size.FOOT_LENGTH !== undefined) ? _c('td', [_c('div', {
      staticClass: "form-group-addon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (size.FOOT_LENGTH),
        expression: "size.FOOT_LENGTH"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##.##'),
        expression: "'##.##'"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (size.FOOT_LENGTH)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(size, "FOOT_LENGTH", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-addon"
    }, [_vm._v("cm")])])]) : _vm._e(), _vm._v(" "), (size.BR_SIZE !== undefined) ? _c('td', [_c('div', {
      staticClass: "form-group-addon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (size.BR_SIZE),
        expression: "size.BR_SIZE"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##'),
        expression: "'##'"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (size.BR_SIZE)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(size, "BR_SIZE", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-addon"
    }, [_vm._v("BR")])])]) : _vm._e(), _vm._v(" "), (size.M_US_SIZE !== undefined) ? _c('td', [_c('div', {
      staticClass: "form-group-addon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (size.M_US_SIZE),
        expression: "size.M_US_SIZE"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##'),
        expression: "'##'"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (size.M_US_SIZE)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(size, "M_US_SIZE", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-addon"
    }, [_vm._v("US")])])]) : _vm._e(), _vm._v(" "), (size.EU_SIZE !== undefined) ? _c('td', [_c('div', {
      staticClass: "form-group-addon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (size.EU_SIZE),
        expression: "size.EU_SIZE"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##'),
        expression: "'##'"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (size.EU_SIZE)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(size, "EU_SIZE", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-addon"
    }, [_vm._v("EU")])])]) : _vm._e()]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Salvar")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c08b7e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SizeGrid/MercadoLivre/Edit.vue
// module id = 3200
// module chunks = 0